import { SITE } from './pages'

const abs = (path) => `${SITE.domain}${path.startsWith('/') ? path : `/${path}`}`

export function buildSoftwareApplication(page) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: page.h1,
    url: abs(page.canonical),
    applicationCategory: 'UtilityApplication',
    operatingSystem: 'Any',
    description: page.metaDescription,
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    publisher: { '@type': 'Organization', name: SITE.name, url: SITE.domain },
  }
}

export function buildFAQ(page) {
  if (!page.faq?.length) return null
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: page.faq.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  }
}

export function buildBreadcrumb(page) {
  if (!page.breadcrumbs || page.breadcrumbs.length < 2) return null
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: page.breadcrumbs.map((b, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: b.name,
      item: abs(b.path),
    })),
  }
}

export function buildHowTo(page) {
  if (!page.howTo?.length) return null
  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: `How to use the ${page.h1}`,
    description: page.intro,
    step: page.howTo.map((s, i) => ({
      '@type': 'HowToStep',
      position: i + 1,
      name: s.name,
      text: s.text,
    })),
  }
}

export function buildWebSite() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.name,
    url: SITE.domain,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE.domain}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  }
}

export function buildOrganization() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE.domain,
    logo: SITE.logo,
    description:
      'EveryKits is a free browser-based utility platform offering age calculators, percentage calculators, text and image tools, and developer utilities.',
  }
}

export function buildBlogPosting(page) {
  if (!page.publishDate) return null
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: page.h1,
    description: page.metaDescription,
    image: page.featuredImage ? abs(page.featuredImage) : SITE.ogImage,
    datePublished: page.publishDate,
    dateModified: page.modifiedDate || page.publishDate,
    author: { '@type': 'Organization', name: page.author || SITE.name },
    publisher: {
      '@type': 'Organization',
      name: SITE.name,
      logo: { '@type': 'ImageObject', url: SITE.logo },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': abs(page.canonical) },
  }
}